import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { LookupsResourcesAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getContainerStates = createAsyncThunk<LookupsResourcesAPI[]>(
  `${Slices.CONTAINER_STATES_LIST}/get`,
  async (_, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get('/lookups/resources/container_state');
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
